/**
* p05固有プロパティー 
*/

export const map = new Map([

/* 画像格納 */
/* 店舗ロゴ格納最大サイズ */
['shp.logo.width','128'],
['shp.logo.height','128'],
/* 店舗画像格納最大サイズ */
['shp.img.width','800'],
['shp.img.height','200'],
/* 1ユーザーが同一店舗でアップロードできる写真の上限 */
['shp.img.max.uploadByUser','5'],
/* 店舗がアップロードできる写真の上限 */
['shp.img.max.uploadByShop','100'],

/* Email */
['05001.email.id','sprt@kinitta.com'],
['05001.email.pw','KaguraKNT2023'],
['05001.email.from','sprt@kinitta.com'],
['05001.email.sprt','sprt@kinitta.com'],
['05001.email.domain','kinitta.com'],
['05001.smtp','mail.kinitta.com'],
['05001.smtp.port','587'],

/* localstorage */
['05001.ls.datatype.personal','10'],
['05001.ls.datatype.project','20'],
['05001.ls.datatype.public','30'],
['05002.ls.datatype.personal','10'],
['05002.ls.datatype.project','20'],
['05002.ls.datatype.public','30'],

/* 店舗付属情報 */
['shop.info.type.nearstation','1'],
/* 契約状況コード */
['shop.stts.cd.system.regist','00'],
['shop.stts.cd.user.regist','10'],
['shop.stts.cd.shop.regist','11'],
['shop.stts.cd.shop.apply','15'],
['shop.stts.cd.shop.approved','20'],
/* 最大件数 */
['shop.search.result.max','100'],
['photo.search.result.max','100'],
['goodLuck.search.result.max.1','10'],
['goodLuck.search.result.max.2','100'],
['shpChkCmnt.display.max','30'],

/* 売上種別 */
['shop.erng.typ.shop','01'],
['shop.erng.typ.takeout','02'],
['shop.erng.typ.web','03'],

/*------------------------------------- */
/* プロジェクト有料オプション(MPT062) */
/*------------------------------------- */
/* メンバー管理 */
['option.p05002.members','05002001'],
/* ポイント管理 */
['option.p05002.points','05002002'],

/*------------------------------------- */
/* 店舗付属情報レコードタイプ(MPT155) */
/*------------------------------------- */
/* 最寄り駅 */
['mpt151.shpInfRecTyp.station','1'],
/* 店舗説明 */
['mpt151.shpInfRecTyp.desc','2'],

/* 画面ごとの設定 */
['s05001003.cal.months.past','12'],
['s05001003.cal.months.future','24'],
['s05001102.cal.months.past','12'],
['s05001102.cal.months.future','24'],

/*------------------------------------- */
/* 会員ランク(MPT160) */
/*------------------------------------- */
/* 会員ランクデフォルト名称 */
['mpt160.mbrRnkCd.1.nm','レギュラー'],
['mpt160.mbrRnkCd.2.nm','シルバー'],
['mpt160.mbrRnkCd.3.nm','ゴールド'],

/*------------------------------------- */
/* 会員ランク別ポイントマスター(MPT161) */
/*------------------------------------- */
/* ポイント種別 */
['mpt160.pntTyp.0001','入会ポイント'],
['mpt160.pntTyp.0002','来店ポイント'],          
['mpt160.pntTyp.0003','ネット予約ポイント'],  
['mpt160.pntTyp.0004','会計ポイント'],  
['mpt160.pntTyp.0005','調整ポイント'],
['mpt160.pntTyp.0006','失効ポイント'],

/* ポイント加減コード */
['mpt160.pntPmCd.p','P'],           // 加算
['mpt160.pntPmCd.m','M'],           // 減算

/* ポイントシステム開始年月 */
['point.started.yyyymm','202301'],

/*------------------------------------- */
/* Firebase用                           */
/*------------------------------------- */

['firebase.chat.doc.shop_customer','chat1'],  // 店舗、顧客チャット用ドキュメントID
// Firebase Consoleで発行された公開鍵
// ['firebase.vapid.key','BDdjHGCzU0GieVPues-cVVHJfqtXdTdE4I9IlylFOfobceGHFbzDtrRZexk-T6l-UD0MyWBp1qQ7OTtH1_cIvg0'], // p05002
['firebase.vapid.key','BDLCErROfY9lLAyo2Vr75_GkLT496fI4UMNPR4jw3GnSEr_UyQdXMDkVAqNF84XpIMKfncblyK36kcUFdGZVwrU'], // p05001
]);


/* ポイント有効月数 */
export const pnt_efct_mnts: any = 
[
  [0,"ポイント有効期限なし"],
  [1,"ポイント有効期限：1ヶ月後の月末"],
  [2,"ポイント有効期限：2ヶ月後の月末"],
  [3,"ポイント有効期限：3ヶ月後の月末"],
  [4,"ポイント有効期限：4ヶ月後の月末"],
  [5,"ポイント有効期限：5ヶ月後の月末"],
  [6,"ポイント有効期限：6ヶ月後の月末"],
  [7,"ポイント有効期限：7ヶ月後の月末"],
  [8,"ポイント有効期限：8ヶ月後の月末"],
  [9,"ポイント有効期限：9ヶ月後の月末"],
  [10,"ポイント有効期限：10ヶ月後の月末"],
  [11,"ポイント有効期限：11ヶ月後の月末"],
  [12,"ポイント有効期限：12ヶ月後の月末"]
];

/* 一か月ごとのプルダウン表 */
export const pnt_cstmr_mnts: any = 
[
  [0,"1カ月"],
  [1,"2カ月"],
  [2,"3カ月"],
  [3,"4カ月"],
  [4,"5カ月"],
  [5,"6カ月"],
  [6,"7カ月"],
  [7,"8カ月"],
  [8,"9カ月"],
  [9,"10カ月"],
  [10,"11カ月"],
  [11,"12カ月"],
  [12,"13カ月"],
  [13,"14カ月"],
  [14,"15カ月"],
  [15,"16カ月"],
  [16,"17カ月"],
  [17,"18カ月"],
  [18,"19カ月"],
  [19,"20カ月"],
  [20,"21カ月"],
  [21,"22カ月"],
  [22,"23カ月"],
  [23,"24カ月"],



];
